import { useEffect, useRef } from 'react';

const useAgGridOutsideClick = (gridApi: any, enabled: boolean = true, containerId?: string) => {
  // Store the container ID
  const containerIdRef = useRef(containerId);

  const handleSidebarButtonClick = (event: any) => {
    if (!gridApi || gridApi.isDestroyed()) return;
    const openedToolPanel = gridApi.getOpenedToolPanel();
    openedToolPanel === event.key ? gridApi.closeToolPanel() : gridApi.openToolPanel();
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (!gridApi || gridApi.isDestroyed()) return;
    const openedToolPanel = gridApi.getOpenedToolPanel();
    if (!openedToolPanel) return;

    // Find sidebars
    const sideBars = document.querySelectorAll('.ag-side-bar');
    let isClickInsideSidebar = false;

    // Check if the click is inside any sidebar
    sideBars.forEach((sidebar) => {
      if (sidebar.contains(event.target as Node)) {
        isClickInsideSidebar = true;
      }
    });

    if (isClickInsideSidebar) return;

    // Get the container to check if it's visible
    if (containerIdRef.current) {
      const container = document.getElementById(containerIdRef.current);
      if (container) {
        const style = window.getComputedStyle(container);
        // Don't process clicks for hidden containers
        if (style.visibility === 'hidden' || style.display === 'none') {
          return;
        }
      }
    }

    if (!gridApi.isDestroyed()) gridApi.closeToolPanel();
  };

  useEffect(() => {
    if (enabled && gridApi && !gridApi.isDestroyed()) {
      gridApi.addEventListener('sideBarButtonClicked', handleSidebarButtonClick);
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      if (gridApi && !gridApi.isDestroyed()) {
        gridApi.removeEventListener('sideBarButtonClicked', handleSidebarButtonClick);
      }
      document.removeEventListener('click', handleClickOutside);
    };
  }, [gridApi, enabled]);
};

export default useAgGridOutsideClick;
